<template>
  <div>
    <div
      v-if="actionDetails.title"
      class="suggested-action-details-item"
    >
      <div
        v-if="existingResource?.title && showDiff && expanded"
        class="suggested-action-item-wrap"
      >
        <span class="suggested-action-item-title text-lg font-medium line-through">
          {{ existingResource?.title }}
        </span>
      </div>
      <div class="suggested-action-item-wrap">
        <span class="suggested-action-item-title text-lg font-medium">
          {{ actionDetails.title }}
        </span>
      </div>
    </div>
    <div
      v-if="actionDetails.content"
      class="suggested-action-details-item"
    >
      <div
        v-if="existingResource?.content && showDiff && expanded"
        class="suggested-action-item-wrap"
      >
        <span class="suggested-action-item-title line-through">
          {{ existingResource?.content }}
        </span>
      </div>
      <div class="suggested-action-item-wrap">
        <span class="suggested-action-item-title">
          {{ actionDetails.content }}
        </span>
      </div>
    </div>
    <div class="suggested-action-details-item mt-2">
      <div class="suggested-action-item-wrap gap-1">
        <em
          v-if="filteredAssignees?.length > 0 && membersPrefixIcon"
          class="custom-icons h-4 w-4 bg-icon-default"
          :style="getCustomIconStyle(iconPath(membersPrefixIcon))"
        />
        <div
          v-if="filteredAssignees?.length > 1"
          class="suggestion-avatars flex"
        >
          <UserAvatar
            v-for="avatar in filteredAssignees"
            :key="avatar"
            :member="{ id: avatar }"
            :group-avatar-id="groupAvatarId"
            :size="'small'"
            class="z-[1] suggestion-avatar"
          />
        </div>
        <UserFieldDisplay
          v-if="filteredAssignees?.length === 1"
          :user-ids="filteredAssignees"
          :action-type="actionType"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import UserFieldDisplay from '@/components/widgets/UserFieldDisplay';
import { computed } from 'vue';
import { useStore } from 'vuex';
import UserAvatar from '@/components/widgets/UserAvatar.vue';
import { nanoid } from 'nanoid';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import useSuggestedActions from '@/utilities/composables/useSuggestedActions';

const store = useStore();
const { iconPath, getCustomIconStyle } = useCustomIcon();
const { actionTypeDefinitions } = useSuggestedActions();

const props = defineProps({
  actionDetails: {
    type: Object,
    required: true,
  },
  actionType: {
    type: String,
    required: true,
  },
  showDiff: {
    type: Boolean,
    required: true,
  },
  expanded: {
    type: Boolean,
    required: true,
  },
  cardId: {
    type: String,
    required: true,
  },
});

const existingResource = computed(() => {
  return store.getters.getCardById(props.cardId);
});

const filteredAssignees = computed(() => {
  return (props.actionDetails?.assignees ?? []).filter((assignee) => {
    const member = store.getters.getMemberById(assignee);
    return member?.id;
  });
});

const groupAvatarId = computed(() => {
  return `group-avatar-${nanoid(6)}`;
});

const membersPrefixIcon = computed(() => {
  return actionTypeDefinitions[props.actionType]?.prefixIcon;
});
</script>

<style lang="scss">
.suggestion-avatar {
  @apply z-[1];
  .avatar {
    @apply border border-solid border-important-bg;
  }

  & + & {
    @apply -ml-1;
  }
}
</style>
